import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  rewardView: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  result: {
    position: "relative",
    width: "100%",
    maxHeight: 340,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    bottom: 65,
    position: "relative",
  },
  img: {
    position: "absolute",
    animation: "$introEffect 3s linear infinite",
    height: "50vh",
    maxHeight: 480,
  },
  gemContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space12,
  },
  gemIcon: {
    width: 40,
    height: 40,
  },
  gem: {
    fontSize: "60px !important",
    fontWeight: "700 !important",
  },
  "@keyframes introEffect": {
    "0%": {
      transform: "rotate(0)",
    },
    "10%": {
      transform: "rotate(0)",
    },
    "30%": {
      transform: "rotate(50deg)",
    },
    "50%": {
      transform: "rotate(100deg)",
    },
    "80%": {
      transform: "rotate(200deg)",
    },
    "100%": {
      transform: "rotate(300deg)",
    },
  },
}));
